import { IonCol, IonGrid, IonRow } from '@ionic/react';
import { ComponentProps, useMemo } from 'react';

// Components
import { ReportCard } from '@/components/Cards/ReportCard';
// Styles
import styles from '@/components/ReportCardGrid/index.module.css';

import { sortReportInfosDict } from '@/utils';
import { isDevelopment } from '@/utils/environment';
import { mergeClassNames } from '@/utils/mergeClassNames';

// Types
import { ReportInfoDict } from '@/models';

interface ReportCardGridProps extends Omit<ComponentProps<typeof IonGrid>, 'class'> {
  data: ReportInfoDict;
}

export const ReportCardGrid = ({ data, className, ...props }: ReportCardGridProps) => {
  // Show  4 or 6 reportCards depending on the environment
  const limit = isDevelopment ? 4 : 6;

  const list = useMemo(() => {
    const sortedList = sortReportInfosDict(data);
    // Limit the number of items based on the environment
    const limitedList = Object.fromEntries(Object.entries(sortedList).slice(0, limit));
    return limitedList;
  }, [data, limit]);

  return (
    <IonGrid {...props} className={mergeClassNames(styles.grid, className)}>
      <IonRow className={styles.row}>
        {Object.keys(list).map((key) => (
          <IonCol className={styles.col} key={key} size='12' sizeLg='6' sizeXl='4'>
            <ReportCard
              date={list[key].uploadTimestamp}
              id={list[key].id ?? ''}
              majorVersion={list[key].version?.col0}
              name={list[key].reportName}
              reportType={list[key].reportType}
              status={list[key].status}
            />
          </IonCol>
        ))}
      </IonRow>
    </IonGrid>
  );
};
